export const FEATURE_FLAGS_STORE = 'featureFlags/store';
export const FEATURE_FLAGS_DESTROY = 'featureFlags/destroy';

export default {
  FEATURE_FLAGS_STORE,
  FEATURE_FLAGS_DESTROY,
};
